import { has } from '@amcharts/amcharts4/.internal/core/utils/Array';

export function getRecommendations(risk_factors, risk_evaluation) {
  const rec = {
    NICE: 'general_recommendation',
    BAG: 'general_recommendation',
    LUKS: 'general_recommendation',
  };

  let hasBreastCancer = risk_factors?.diagnosed_cancer === 'breast';
  let hasOvarianCancer = risk_factors?.diagnosed_cancer === 'ovarian';
  if (risk_factors?.diagnosed_cancer === 'both_cancer') {
    hasBreastCancer = true;
    hasOvarianCancer = true;
  }

  const age = risk_factors?.age;
  const riskLevel = risk_evaluation?.risk_level;
  const cancerAge = risk_factors?.diagnosed_cancer_age;

  // --- LUKS ---
  if (hasOvarianCancer) {
    if (age >= 75) {
      rec.LUKS = 'LUKS.all.75plus.disease';
    } else if (age >= 50) {
      rec.LUKS = 'LUKS.all.50to74.ovarian';
    } else if (age >= 40) {
      rec.LUKS = 'LUKS.all.40to49.ovarian';
    } else {
      rec.LUKS = 'LUKS.all.20to39.disease';
    }
  } else if (hasBreastCancer) {
    if (age >= 75) {
      rec.LUKS = 'LUKS.all.75plus.disease';
    } else if (age >= 40) {
      if (cancerAge >= 40) {
        rec.LUKS = 'LUKS.all.40to74.bc_ht40';
      } else {
        rec.LUKS = 'LUKS.all.40to74.bc_lt40';
      }
    } else {
      rec.LUKS = 'LUKS.all.20to39.disease';
    }
  } else {
    if (age >= 75 && riskLevel === 'high') {
      rec.LUKS = `LUKS.high.75plus.healthy`;
    } else if (age >= 50) {
      rec.LUKS = `LUKS.${riskLevel}.50to74.healthy`;
    } else if (age >= 40) {
      rec.LUKS = `LUKS.${riskLevel}.40to49.healthy`;
    } else {
      rec.LUKS = `LUKS.${riskLevel}.20to39.healthy`;
    }
  }

  // --- NICE ---
  if (riskLevel === 'low') {
    if (hasBreastCancer || hasOvarianCancer) {
      rec.NICE = 'nice.low.all.disease';
    } else if (age >= 50 && age <= 69) {
      rec.NICE = 'nice.low.50to69.healthy';
    }
  } else if (riskLevel === 'moderate') {
    if (hasBreastCancer || hasOvarianCancer) {
      if (age >= 20 && age <= 29) {
        rec.NICE = 'nice.moderate.20to29.disease';
      } else {
        rec.NICE = 'nice.moderate.all.disease';
      }
    } else {
      if (age >= 40 && age <= 49) {
        rec.NICE = 'nice.moderate.40to49.healthy';
      } else if (age >= 50 && age <= 59) {
        rec.NICE = 'nice.moderate.50to59.healthy';
      } else if (age >= 60 && age <= 69) {
        rec.NICE = 'nice.moderate.60to69.healthy';
      } else if (age >= 70) {
        rec.NICE = 'nice.moderate.70plus.healthy';
      }
    }
  } else {
    if (hasBreastCancer || hasOvarianCancer) {
      if (age >= 30 && age <= 49) {
        rec.NICE = 'nice.high.30to49.disease';
      } else if (age >= 50 && age <= 69) {
        rec.NICE = 'nice.high.50to69.disease';
      } else if (age >= 70) {
        rec.NICE = 'nice.high.70plus.disease';
      }
    } else {
      if (age >= 30 && age <= 39) {
        rec.NICE = 'nice.high.30to39.healthy';
      } else if (age >= 40 && age <= 49) {
        rec.NICE = 'nice.high.40to49.healthy';
      } else if (age >= 50 && age <= 59) {
        rec.NICE = 'nice.high.50to59.healthy';
      } else if (age >= 60 && age <= 69) {
        rec.NICE = 'nice.high.60to69.healthy';
      } else if (age >= 70) {
        rec.NICE = 'nice.high.70plus.healthy';
      }
    }
  }

  // --- BAG ---
  if (!hasBreastCancer && !hasOvarianCancer) {
    if (riskLevel === 'low') {
      if (age >= 50 && age <= 69) {
        rec.BAG = 'bag.low.50to69.healthy';
      }
    } else if (riskLevel === 'moderate') {
      if (age >= 40 && age <= 49) {
        rec.BAG = 'bag.moderate.40to49.healthy';
      } else if (age >= 50 && age <= 59) {
        rec.BAG = 'bag.moderate.50to59.healthy';
      } else if (age >= 60 && age <= 69) {
        rec.BAG = 'bag.moderate.60to69.healthy';
      } else if (age >= 70) {
        rec.BAG = 'bag.moderate.70plus.healthy';
      }
    } else {
      if (age >= 30 && age <= 39) {
        rec.BAG = 'bag.high.30to39.healthy';
      } else if (age >= 40 && age <= 49) {
        rec.BAG = 'bag.high.40to49.healthy';
      } else if (age >= 50 && age <= 59) {
        rec.BAG = 'bag.high.50to59.healthy';
      } else if (age >= 60 && age <= 69) {
        rec.BAG = 'bag.high.60to69.healthy';
      } else if (age >= 70) {
        rec.BAG = 'bag.high.70plus.healthy';
      }
    }
  }
  return rec;
}
